import React from 'react';

const LockIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1667 17.5H5.83341C4.91258 17.5 4.16675 16.7542 4.16675 15.8333V9.16667C4.16675 8.24583 4.91258 7.5 5.83341 7.5H14.1667C15.0876 7.5 15.8334 8.24583 15.8334 9.16667V15.8333C15.8334 16.7542 15.0876 17.5 14.1667 17.5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 7.5V5.83333V5.83333C6.66675 3.9925 8.15925 2.5 10.0001 2.5V2.5C11.8409 2.5 13.3334 3.9925 13.3334 5.83333V5.83333V7.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.5 10.8334H7.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5 14.1667H7.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default LockIcon;
